import * as React from 'react';

const SvgUniqueErgo3 = (props) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 151 150"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m90.883 89.643 59.321 59.255-1.151 1.102-59.305-59.255 1.135-1.102Z"
      fill="url(#unique-ergo-3_svg__a)"
    />
    <path
      d="M74.413 74.305c28.653-28.63 59.881-43.918 69.714-34.14 9.834 9.776-5.516 41.026-34.185 69.655-28.67 28.629-59.881 43.966-69.715 34.141-9.833-9.826 5.5-40.963 34.186-69.656Z"
      stroke="#fff"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M115.318 56.858a41.69 41.69 0 0 1 16.251 27.418 41.667 41.667 0 0 1-7.873 30.879 41.676 41.676 0 0 1-27.437 16.264 41.697 41.697 0 0 1-30.909-7.892 41.624 41.624 0 0 1-8.379-58.297 41.657 41.657 0 0 1 12.1-10.86 41.692 41.692 0 0 1 31.578-4.53 41.685 41.685 0 0 1 14.669 7.018Z"
      fill="url(#unique-ergo-3_svg__b)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M103.198 76.621a.764.764 0 0 1 0 1.103.766.766 0 0 1-1.135 0 122.774 122.774 0 0 1-24.448-35.355C70.244 26.68 66.422 11.168 65.958.83a.846.846 0 0 1 .8-.83.832.832 0 0 1 .847.75c.432 10.257 4.142 25.562 11.465 41.01a120.714 120.714 0 0 0 24.128 34.86ZM76.256 100.89a.847.847 0 0 1 0 1.15.848.848 0 0 1-1.151 0 116.492 116.492 0 0 0-34.138-23.82C25.889 71.222 11.034 67.835.753 67.34a.783.783 0 0 1-.751-.83.767.767 0 0 1 .847-.751c10.441.48 25.583 3.914 40.821 11.055a117.707 117.707 0 0 1 34.586 24.06v.016Zm6.747-6.07a.814.814 0 0 1 0 1.134.816.816 0 0 1-1.15 0 226.818 226.818 0 0 0-31.884-26.648c-13.144-9.17-25.184-15.513-32.987-18.42a.768.768 0 0 1-.447-1.007.784.784 0 0 1 1.023-.496c7.995 2.956 20.067 9.394 33.338 18.596a232.666 232.666 0 0 1 32.107 26.824v.016Zm6.748-6.04a.782.782 0 0 1 0 1.103.848.848 0 0 1-1.151 0C74.8 76.094 60.73 61.908 49.697 50.836 42.95 44.062 37.45 38.503 33.164 34.237a.782.782 0 0 1 0-1.102.816.816 0 0 1 1.151 0c3.342 3.339 9.306 9.298 16.485 16.567C61.433 60.39 75.01 74.049 89.75 88.763v.016Zm6.731-6.087a.75.75 0 0 1 0 1.103.798.798 0 0 1-1.135 0 227.707 227.707 0 0 1-26.91-32.288c-9.386-13.58-15.99-26.04-18.948-34.013a.75.75 0 0 1 .48-1.022.768.768 0 0 1 1.007.447c2.91 7.876 9.45 20.226 18.74 33.71a231.91 231.91 0 0 0 26.767 32.048v.015Z"
      fill="url(#unique-ergo-3_svg__c)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M85.464 85.329c8.779-8.82 18.117-13.756 20.787-11.056 2.67 2.7-2.255 11.982-11.08 20.769-8.827 8.787-18.117 13.755-20.787 11.055-2.67-2.7 2.254-11.902 11.08-20.768ZM129.515 34.476a6.814 6.814 0 0 1 0 9.745 6.896 6.896 0 0 1-9.738 0 6.866 6.866 0 0 1 0-9.745 6.894 6.894 0 0 1 9.738 0ZM59.495 142.906a3.988 3.988 0 0 1 0 5.687 4 4 0 0 1-5.645 0 3.976 3.976 0 0 1 0-5.687 4.03 4.03 0 0 1 5.645 0Z"
      fill="#FF5E18"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M93.841 66.428a1.215 1.215 0 0 1-1.678-.224 1.198 1.198 0 0 1 .223-1.597 86.722 86.722 0 0 1 22.849-13.548c6.7-2.428 12.073-2.38 15.031.623 2.958 3.004 3.006 8.324.623 15.018a89.991 89.991 0 0 1-13.495 22.83 1.278 1.278 0 0 1-1.727.223 1.196 1.196 0 0 1-.176-1.677 87.85 87.85 0 0 0 13.144-22.16c2.078-5.83 2.206-10.32 0-12.556-2.207-2.237-6.748-2.125-12.568 0a85.21 85.21 0 0 0-22.226 13.068Zm-5.692 48.903a1.263 1.263 0 0 1 1.727.224 1.18 1.18 0 0 1-.224 1.597 87.147 87.147 0 0 1-22.88 13.484c-6.717 2.428-12.041 2.38-15.047-.607-3.006-2.988-2.99-8.34-.576-15.034a88.566 88.566 0 0 1 13.495-22.813 1.2 1.2 0 0 1 1.68-.224 1.198 1.198 0 0 1 .223 1.597 84.826 84.826 0 0 0-13.143 22.207c-2.079 5.768-2.207 10.257 0 12.51 2.206 2.252 6.747 2.108 12.52 0 6.395-2.125 14.118-6.647 22.225-12.941Z"
      fill="url(#unique-ergo-3_svg__d)"
    />
    <path
      d="M80.972 80.823c16.885-16.87 34.794-26.344 39.974-21.184 5.181 5.16-4.365 23.037-21.25 39.94-16.885 16.903-34.745 26.345-39.974 21.184-5.228-5.16 4.35-23.053 21.25-39.94Z"
      stroke="url(#unique-ergo-3_svg__e)"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="unique-ergo-3_svg__a"
        x1={129.946}
        y1={140.526}
        x2={100.527}
        y2={110.476}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0} />
        <stop offset={0.505} stopColor="#DBDBDB" />
        <stop offset={1} stopColor="#FF5E18" />
      </linearGradient>
      <linearGradient
        id="unique-ergo-3_svg__c"
        x1={29.212}
        y1={33.486}
        x2={81.136}
        y2={83.854}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0} />
        <stop offset={0.515} stopColor="#824E38" />
        <stop offset={1} stopColor="#FF5E18" />
      </linearGradient>
      <linearGradient
        id="unique-ergo-3_svg__d"
        x1={83.577}
        y1={75.822}
        x2={117.929}
        y2={106.205}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0} />
        <stop offset={0.526} stopColor="#FF5E18" />
      </linearGradient>
      <linearGradient
        id="unique-ergo-3_svg__e"
        x1={102.136}
        y1={103.416}
        x2={81.196}
        y2={84.186}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <radialGradient
        id="unique-ergo-3_svg__b"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(48.745 -54.38 144.783) scale(38.2633 38.253)"
      >
        <stop stopColor="#FF5E18" />
        <stop offset={0.578} stopColor="#FF5E18" />
        <stop offset={0.97} stopColor="#FF5E18" stopOpacity={0} />
      </radialGradient>
    </defs>
  </svg>
);

export default SvgUniqueErgo3;
